import React from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default class Notification extends React.Component {
    constructor (props) {
        super(props);
        
        this.state = {
            toastId: this.props.toastId || null,
            message: this.props.message,
            notificationType: this.props.notificationType ? this.props.notificationType : toast.TYPE.DEFAULT,
            defaultNotificationType:toast.TYPE.DEFAULT
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            toastId: nextProps.toastId || this.state.toastId,
            message: nextProps.message,
            notificationType:nextProps.notificationType ? nextProps.notificationType : this.state.defaultNotificationType,
        }, function() {
            this.notify();
        });
        
    }

    componentDidMount() {
        this.notify();
    }
    
    displayToast = (toastId) => {
        const { notificationType, message } = this.state
        
        if ( toastId ) {
            toast(message, { toastId, type: notificationType, autoClose: 2500 });
            
        } else {
            toastId = toast(message, { type: notificationType, autoClose: 2500 });
        }
        this.setState({toastId})
        
    } 

    notify = () => {
        const { toastId } = this.state;
        this.displayToast(toastId);
        this.setState({toastId})
    }

    render () {
        return (<ToastContainer
            position="bottom-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnVisibilityChange
            draggable
            pauseOnHover
        />);
    }
}


// WEBPACK FOOTER //
// ./src/components/UI/Widget/Notification.js